module.exports = __webpack_public_path__ + "media/vr2.8c1765df.mp3";